export default "__VITE_ASSET__28ff680f__"